import { CustomModalLayout } from '@wix/design-system';
import { CycleUtils, useFormatDate } from '@wix/package-picker-shared';
import React from 'react';
import { SwitchProductModule } from '../../switch-product.module';
import { PlanFeaturesModalContent } from './PlanFeaturesModalContent';
export const PlanFeaturesModal = _ref => {
  var _currentProductData$c, _currentProductData$c2, _currentProductData$c3, _currentProductData$c4;
  let {
    onClose,
    onShow
  } = _ref;
  const {
    t
  } = SwitchProductModule.internals.useTranslations();
  const {
    locale
  } = SwitchProductModule.internals.useContext();
  const formatDate = useFormatDate({
    locale
  });
  const {
    data: currentProductData
  } = SwitchProductModule.SDK.switchApiClient.hooks.useGetCurrentProduct({});
  const cycleKey = `change_plan.current_plan_modal.${CycleUtils.convertToBillingPaymentCycle(currentProductData == null || (_currentProductData$c = currentProductData.currentProduct) == null ? void 0 : _currentProductData$c.cycle)}.billed`;
  const monthlyPrice = currentProductData == null || (_currentProductData$c2 = currentProductData.currentProduct) == null || (_currentProductData$c2 = _currentProductData$c2.pricing) == null || (_currentProductData$c2 = _currentProductData$c2.monthlyTotal) == null ? void 0 : _currentProductData$c2.formattedAmount;
  const subtitleKey = monthlyPrice ? 'change_plan.current_plan_modal.payment_details_advanced' : 'change_plan.current_plan_modal.payment_details_advanced.new';
  const subtitle = t(subtitleKey, {
    planName: currentProductData == null || (_currentProductData$c3 = currentProductData.currentProduct) == null ? void 0 : _currentProductData$c3.productName,
    price: monthlyPrice,
    cycle: t(cycleKey),
    endDate: formatDate((currentProductData == null || (_currentProductData$c4 = currentProductData.currentProduct) == null ? void 0 : _currentProductData$c4.periodEndDate) ?? undefined)
  });
  const handleClose = () => {
    onClose == null || onClose();
    SwitchProductModule.SDK.modalsController.PlanFeaturesModal.hide();
  };
  React.useEffect(() => {
    onShow == null || onShow();
  }, [onShow]);
  return /*#__PURE__*/React.createElement(CustomModalLayout, {
    maxHeight: "700px",
    showFooterDivider: true,
    onCloseButtonClick: handleClose,
    title: t('Advanced.Plans_change.plan_modal.view_current_plan_title'),
    subtitle: subtitle,
    primaryButtonText: t('change_plan.current_plan_modal.close'),
    primaryButtonOnClick: handleClose
  }, /*#__PURE__*/React.createElement(PlanFeaturesModalContent, null));
};
//# sourceMappingURL=PlanFeaturesModal.js.map